// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__SMxyS","content":"GlobalSearch_content__1K0IG"};